import Content from './content';
import { useState, useRef } from 'react';
import Button from '@CS/components/Button';
import { useTranslation } from '@CS/hooks';
import CSS from './SurvivalMode.module.css';
import { Popup } from '@CS/components/Popups';
import McIcon from '@CS/assets/mcIcon.svg?component';
import { type PopupProps } from '@CS/components/Popups';
import type { LangCopy } from '@CS/components/TranslationProvider/types';

type SurvivalModeProps = PopupProps & {
  onSubmit: () => void;
  onCancel: () => void;
  points: number;
  score?: number;
  price: number;
};

export const SurvivalMode = ({
  onSubmit,
  onCancel,
  onClose,
  points,
  price,
  ...props
}: SurvivalModeProps) => {
  const submitPoints = useRef(false);
  const [visible, setVisible] = useState(true);

  const title = useTranslation(Content.title);
  const submit = useTranslation(Content.submit);
  const cancel = useTranslation(Content.cancel);
  const balance = useTranslation(Content.balance);

  const onPopupClose = () =>
    ~(submitPoints.current ? onSubmit() : onCancel()) && onClose?.();

  const description = useTranslation(
    Content.description as unknown as LangCopy
  ) as unknown as (price: number) => string;

  const onSubmitClick = () => {
    submitPoints.current = true;
    setVisible(false);
  };

  const onCancelClick = () => {
    submitPoints.current = false;
    setVisible(false);
  };

  return (
    <Popup onClose={onPopupClose} close={!visible} hideClose {...props}>
      <div className={CSS.survivalContainer}>
        <h3 className={CSS.survivalTitle}>{title}</h3>
        <p className={CSS.survivalDescription}>{description(price)}</p>
        <label className={CSS.survivalBalance}>{balance}</label>

        <em className={CSS.survivalPoints}>
          <McIcon />
          {points}
        </em>

        <Button
          disabled={points < price}
          onClick={onSubmitClick}
          text={submit}
          width="100%"
        />

        <Button
          className={CSS.survivalCancelButton}
          onClick={onCancelClick}
          width="100%"
        >
          {cancel}
        </Button>
      </div>
    </Popup>
  );
};
